module.exports = __webpack_public_path__ + "img/call-outgoing.ed5258e5.svg";